module.exports = __webpack_public_path__ + "static/media/Pilot.0a5e0304.jpg";